import { HttpAgentUnderwriterService } from '../../../../service/http-agent.service';
import { Component } from '@angular/core';
import { AgentDto } from '../../../../service/dto';

@Component({
  selector: 'app-agent-underwriter-list',
  standalone: false,
  templateUrl: './agent-underwriter-list.component.html',
  styleUrl: './agent-underwriter-list.component.scss'
})
export class AgentUnderwriterListComponent {
	data: AgentDto[] = [];
	constructor(private httpService: HttpAgentUnderwriterService){

	}
	ngOnInit(): void {
		this.httpService.getAll().subscribe(result => this.data=result);
	}

}
